import React from 'react';
import ReactDOM from 'react-dom/client';

// Fonts — must precede the token sheet so font-face declarations are
// available when tokens.css points --font-sans/--font-mono at them.
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

// Design system — tokens before any other CSS, base reset right after.
import './core/ui/tokens.css';
import './core/ui/base.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals();
